import React, { useState, useEffect } from "react";
import SectorPerformanceChart from "./SectorPerformanceChart";
import TimeSlider from "./TimeSlider";
import { getsectorData } from "../../data/sectorData";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Play, Pause, RefreshCw } from "lucide-react";
import { cn } from "../../lib/utils";
import { useIsMobile } from "../../hooks/use-mobile";

const SectorPulse: React.FC = () => {
  const [sectorHistoricalData, setsectorHistoricalData] = useState([])
  const [currentDateIndex, setCurrentDateIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(true)
  const dates = sectorHistoricalData.map((item) => item.date);
  const currentData = sectorHistoricalData[currentDateIndex];
  const previousData = currentDateIndex > 0
    ? sectorHistoricalData[currentDateIndex - 1].sectors
    : undefined;
  const [refreshing, setrefreshing] = useState(false)
  useEffect(() => {
    let interval: number | undefined;
    if (isPlaying) {
      interval = window.setInterval(() => {
        setCurrentDateIndex((prev) => {
          if (prev >= sectorHistoricalData.length - 1) {
            setIsPlaying(false);
            return prev;
          }
          return prev + 1;
        });
      }, 1500);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isPlaying]);
  useEffect(() => {
    setLoading(true)
    const settingitbrro = getsectorData()
    setsectorHistoricalData(settingitbrro)
    setCurrentDateIndex(settingitbrro.length - 1)
    setLoading(false)
  }, [])

  const togglePlayback = () => {
    if (currentDateIndex === sectorHistoricalData.length - 1) {
      setCurrentDateIndex(0);
    }
    setIsPlaying(!isPlaying);
  };
  const handleRefresh = async () => {
    setrefreshing(true);
    setIsPlaying(false); // optional: pause playback on refresh
    const updatedData = getsectorData(); // or await if it's async
    setsectorHistoricalData(updatedData);
    setCurrentDateIndex(updatedData.length - 1);
    setrefreshing(false);
  };

  if (loading)
    return (<>Loading...</>)
  return (
    <div className={cn(
      "bg-black/40 rounded-lg border border-white/10",
      isMobile ? "p-3" : "p-4"
    )}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-white">Sector Pulse</h3>
        <div className="flex gap-2">
          <Button
            onClick={handleRefresh}
            disabled={refreshing}
            variant="outline"
            size="sm"
            className="bg-black/20 hover:bg-white/5 text-white"
          >
            <RefreshCw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
          </Button>
        </div>
      </div>
      <div className="space-y-6">
        <SectorPerformanceChart
          data={currentData?.sectors}
          date={currentData?.date}
          previousData={previousData}
        />
        <div className="space-y-4">
          <TimeSlider
            dates={dates}
            currentDateIndex={currentDateIndex}
            onChange={setCurrentDateIndex}
          />
          <div className="flex justify-center">
            <Button
              onClick={togglePlayback}
              variant="outline"
              size="lg"
              className="bg-black/20 hover:bg-white/5 text-white transition-all duration-300"
            >
              {isPlaying ? (
                <><Pause className="mr-2 h-4 w-4" /> Pause</>
              ) : (
                <><Play className="mr-2 h-4 w-4" /> Replay</>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectorPulse;
